import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        buildForm(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/triage/build/${id}`)
                    .then((res) => {
                        resolve(res.data.data.form);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getValues(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/triage/values/${id}`)
                    .then((res) => {
                        resolve(res.data.data.values);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveItemValue(_, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/triage/items/value", payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        saveItemFileValue(commit, payload) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                for (const i in payload) {
                    if (payload[i] !== null && i !== "files_value") {
                        formData.append(i, payload[i]);
                    }
                }
                const files_value = payload.files_value;
                for (const val in files_value) {
                    formData.append(`files_value[${val}]`, files_value[val]);
                }
                axios
                    .post("/triage/items/value", formData)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        finishAppointment(commit, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/triage/finish/${id}`)
                    .then((res) => {
                        resolve(res.data.data.finished_at);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        downloadTriageReport({}, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/triage/report/${id}`, {
                        responseType: "blob",
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
